import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useSellingPrice } from "./hooks";

export const QuestionSellingPrice = () => {
	const { sellingPrice, onSetSellingPriceAmount } = useSellingPrice();

	const title = "販売価格";
	const guide = "ゲストに販売する際の価格設定です。";

	return (
		<QuestionForMain
			required={true}
			title={title}
			guide={guide}
			inputChildren={
				<QuestionSectionWrapper>
					<p>販売価格：</p>
					<InputNumberField
						value={sellingPrice.amount?.value}
						handleInput={onSetSellingPriceAmount}
						errorMessage={sellingPrice.amount?.error}
					/>
					<p>円（税込）</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionSellingPrice.displayName = "QuestionSellingPrice";
